import uuid from "react-uuid";
import { push } from "connected-react-router";
import {
  APP_APIS_V2_URL,
  IMAGE_UPLOAD_URL,
  BASE_URL,
} from "../config/constants";
import { getUserStats } from "./uploader";
import { fetchAPI, logout } from "./index";

export const checkProAuth = (pro_auth) => (dispatch) => {
  const {
    pro_token: token,
    pro_user_id: user_id,
    project_uuid,
    pro_td_version_id: td_version_id,
  } = pro_auth;
  const fd = new FormData();
  fd.append("user_id", user_id);
  fd.append("token", token);
  fetchAPI({
    url: BASE_URL + "/apis/auth",
    fd,
    token,
    success: () => {
      dispatch({ type: "PRO_SET_AUTH", payload: pro_auth });
      dispatch({
        type: "SET_CONFIG_DATA",
        payload: { project_id: project_uuid, td_version_id, shops: [] },
      });
      dispatch(push("/home"));
    },
    failure: () => dispatch(logout()),
    catchFunc: () => dispatch(logout()),
  });
};

const buildCategoriesByShopId = (shops) => {
  const categoriesByShopId = {};
  shops.forEach((shopData) => {
    const categoriesList = [];
    shopData.subtasks.forEach((subtask) => {
      let category = categoriesList.find(
        (c) => c.category_id === subtask.category_id,
      );
      if (!category) {
        category = {
          category_id: subtask.category_id,
          category_name: subtask.category_name,
          category_uuid: subtask.category_uuid,
          subtasks: [],
        };
        categoriesList.push(category);
      }
      category.subtasks.push({
        subtask_name: subtask.subtask_name,
        subtask_type: subtask.subtask_type,
        subtask_image_link: subtask.subtask_image_link,
        category_icon_link: subtask.category_icon_link,
        sn_image_type: subtask.sn_image_type,
        capture_instructions: subtask.capture_instructions,
        capture_status: subtask.capture_status,
        capture_date: subtask.capture_date,
        images_uploaded: subtask.images_uploaded,
        image_count: subtask.image_count,
        subtask_description: subtask.subtask_description,
        shelf_type: subtask.shelf_type,
        asset_image_id: subtask.asset_image_id,
        shelf_image_id: subtask.shelf_image_id,
      });
    });
    categoriesByShopId[shopData.shop_id] = categoriesList;
  });
  return categoriesByShopId;
};

export const loginWebappPro = (username, password) => (dispatch) => {
  dispatch({
    type: "PRO_LOADING",
    payload: { loading: true, message: "Logging in..." },
  });

  fetch(APP_APIS_V2_URL + "/api/login", {
    method: "POST",
    body: JSON.stringify({ username, password }),
    headers: { "Content-Type": "application/json" },
  })
    .then((res) => res.json())
    .then((res) => {
      if (res.status) {
        const pro_auth = {
          pro_token: res.token,
          pro_user_id: res.user_id,
          project_uuid: res.project_uuid,
          pro_td_version_id: res.td_version_id,
        };
        localStorage.setItem("pro_auth", JSON.stringify(pro_auth));
        dispatch({ type: "PRO_SET_AUTH", payload: pro_auth });
        dispatch({
          type: "SET_CONFIG_DATA",
          payload: {
            project_id: res.project_uuid,
            td_version_id: res.td_version_id,
            shops: [],
          },
        });
        dispatch({ type: "PRO_LOADING", payload: { loading: false } });
      } else {
        dispatch({ type: "PRO_ERROR", payload: res.message });
      }
    })
    .catch((err) => {
      dispatch({
        type: "PRO_ERROR",
        payload: `Something went wrong: ${err?.message || err}`,
      });
    });
};

export const fetchProData =
  (user_id, project_id, td_version_id, token) => (dispatch) => {
    dispatch({
      type: "PRO_SET_LOADING_MESSAGE",
      payload: "Fetching shops and categories...",
    });

    const fetchWithAuth = (url, extra) =>
      fetch(url, {
        method: "POST",
        body: JSON.stringify({ user_id, project_id, td_version_id, ...extra }),
        headers: { "auth-token": token, "Content-Type": "application/json" },
      }).then((res) => res.json());

    Promise.all([
      fetchWithAuth(APP_APIS_V2_URL + "/api/shop"),
      fetchWithAuth(APP_APIS_V2_URL + "/api/photo_audit", {}),
    ])
      .then(([shopsRes, photoAuditRes]) => {
        if (shopsRes.status && photoAuditRes.status) {
          const categoriesByShopId = buildCategoriesByShopId(
            photoAuditRes.photo_task_data.shops,
          );
          dispatch({
            type: "PRO_SET_DATA",
            payload: { shops: shopsRes.shops, categoriesByShopId },
          });
          dispatch(getUserStats(project_id, td_version_id));
        } else {
          const message = !shopsRes.status
            ? shopsRes.message
            : photoAuditRes.message;
          dispatch({ type: "PRO_ERROR", payload: message });
        }
      })
      .catch((err) => {
        dispatch({
          type: "PRO_ERROR",
          payload: `Something went wrong: ${err?.message || err}`,
        });
      });
  };

export const proSetActiveShop = (shopId) => ({
  type: "PRO_SET_ACTIVE_SHOP",
  payload: shopId,
});

export const proSetActiveCategory = (categoryId) => ({
  type: "PRO_SET_ACTIVE_CATEGORY",
  payload: categoryId,
});

export const proSetActiveSubtask = (subtask) => ({
  type: "PRO_SET_ACTIVE_SUBTASK",
  payload: { subtask, app_session_id: uuid() },
});

export const proToggleUploadView = (type) => (dispatch) => {
  dispatch({ type: "PRO_TOGGLE_UPLOAD_VIEW", payload: type });
  if (!type) dispatch({ type: "PRO_RESET_UPLOADING_IMAGES" });
};

export const proSetUploadingImages = (type, title, fileList) => ({
  type: "PRO_SET_UPLOADING_IMAGES",
  payload: { type, title, fileList },
});

export const proUploadingImageStart = () => ({
  type: "PRO_UPLOADING_IMAGES_START",
});

export const proUploadImages =
  ({ data, context }) =>
  (dispatch, getState) => {
    const { pro_token: token } = getState().webappPro.pro_auth;
    const fd = new FormData();
    Object.keys(data).forEach((key) => fd.append(key, data[key] ?? ""));

    fetch(IMAGE_UPLOAD_URL + "/apis/upload", {
      method: "POST",
      body: fd,
      headers: { "auth-token": token },
    })
      .then((res) => res.json())
      .then((res) => {
        dispatch({ type: "PRO_UPDATE_PROCESSED_COUNTER" });
        if (res.status) {
          dispatch({ type: "PRO_SUCCESS_IMAGE_UPLOAD" });
          dispatch({
            type: "PRO_REMOVE_UPLOADED_IMG",
            payload: context.image_id,
          });
        } else {
          dispatch({ type: "PRO_ERROR", payload: res.message });
        }
      })
      .catch((err) => {
        dispatch({ type: "PRO_UPDATE_PROCESSED_COUNTER" });
        dispatch({
          type: "PRO_ERROR",
          payload: `Something went wrong: ${err?.message || err}`,
        });
      });
  };
